// @flow
import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import DisplayPopover from "./DisplayPopover";
import { ColorSchema } from "../../global/types/scss";
import { CopyRight } from "../containers/CopyRight";
import Properties from "../../Properties.js";

class Display extends Component<*> {
  render(): React$Element<*> {
    const conference = this.props.db.conference;
    let banner = "/images/welcome.svg";
    if (conference.has_banner) {
      banner = `${Properties.api_root}/api/v2/conferences/${conference.id}/logo?type=banner`;
    }
    let description = `
            This website's aim is to demonstrate how Imagus' facial recognition technology can be used as a supplement for
            old-fashioned nametags to recognise attendees and welcome them to the conference.
            `;
    if (conference.theme && conference.theme.description) {
      description = <ReactMarkdown source={conference.theme.description} />;
    }

    const conferenceNotes = conference.sidebar_notes;
    const len = conferenceNotes.length !== 0 ? conferenceNotes.length : 1;
    const notes = conferenceNotes && conferenceNotes.map((note: string, i: number) => {
      return (
        <span key={i}>
          ({i+1})&nbsp;
          {note} 
          <br /><br />
        </span>
      );
    });
    return (
      <div className="left-wrapper" style={{ backgroundColor: ColorSchema("primary") }} >
        <div className="inner-wrapper">
          <Typography variant="subheading" className="white-title display-text main-header">
            {description}
          </Typography>
          <img src={banner} className="welcome-img" />
          <Typography variant="subheading" className="white-title display-text main-header">
            <b>Please take note:</b><br />
            {notes.length !== 0 && 
              notes
            ||
            <span>
              (1)&nbsp;
              By clicking 'Submit', you have given your permission to share your personal information with other delegates at the conference.
              <br /><br />
            </span>
            }
            ({len + 1})&nbsp; After submission, you will receive a email verification link separately to edit your profile and upload your photo images.
            <br /><br />
            ({len + 2})&nbsp; You can upload more photo(s) using the same email verification link at any time.&nbsp;
            <DisplayPopover handleRequestClose={this.props.handleRequestClose} />
          </Typography>
          <Typography variant="body1" className="white-title form-text fixed-bottom">
            <span className="">{CopyRight}</span>
          </Typography>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

export default connect(mapStateToProps)(Display);


// WEBPACK FOOTER //
// ./src/conference/component/Display.js